(() => {
  const start = () => {
  if (document.body && document.body.classList.contains("is-505")) return;
  const root = document.querySelector("[data-photos]");
  if (!root) return;
  const win = root.closest(".os-win");
  const title = win && win.querySelector(".os-win__bar span");

  const THUMB = 420;
  const MEDIUM = 1100;
  const FULL = 1600;
  const extra = (() => {
    const node = document.querySelector("[data-photos-albums]");
    if (!node) return [];
    try {
      const parsed = JSON.parse((node.textContent || "").replace(/^\uFEFF/, "").trim() || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) { return []; }
  })();
  const ALBUMS = [
    {
      id: "house-stills",
      name: "HOUSE STILLS",
      date: "2018-05-05",
      desc: "Loose frames from the public folder. Not a lookbook.",
      files: [
        {
          name: "DSC00344.JPG",
          src: "https://cdn.shopify.com/s/files/1/0893/9218/5692/files/DSC00344.jpg?v=1738948251",
          desc: "Object still. Worn like jewellery that could cut you."
        },
        {
          name: "IMG-2446.JPG",
          src: "https://cdn.shopify.com/s/files/1/0893/9218/5692/files/IMG-2446.jpg?v=1738843927",
          desc: "A frame from the house. Clothes are one output."
        },
        {
          name: "CHAINIMAGE.PNG",
          src: "https://cdn.shopify.com/s/files/1/0893/9218/5692/files/CHAINIMAGE.png?v=1738947071",
          desc: "Steel on paper. Scumboy / Blackwater."
        }
      ]
    },
    ...extra
  ];

  const sized = (src, w) => {
    try {
      const u = new URL(src, location.href);
      u.searchParams.set("width", String(w));
      return u.toString();
    } catch (_) {
      return src;
    }
  };

  const loaded = new Map();
  const loadImg = (src) => {
    if (!src) return Promise.reject();
    if (loaded.has(src)) return loaded.get(src);
    const p = new Promise((resolve, reject) => {
      const im = new Image();
      im.onload = () => {
        const ok = () => resolve(im);
        if (im.decode) im.decode().then(ok, ok);
        else ok();
      };
      im.onerror = () => {
        loaded.delete(src);
        reject(new Error("photo"));
      };
      im.src = src;
    });
    loaded.set(src, p);
    return p;
  };

  const warm = (file, w) => {
    if (!file) return;
    loadImg(sized(file.src, w)).catch(() => {});
  };

  const pad = (n) => String(n).padStart(2, "0");

  const state = { mode: "index", album: null, i: 0, live: false, sort: "newest" };
  const SORTS = ["newest", "oldest", "most", "least"];

  const dateStamp = (album) => {
    const raw = String((album && album.date) || "").trim();
    const m = raw.match(/^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?/);
    if (!m) return 0;
    return Date.UTC(Number(m[1]), Number(m[2] || 1) - 1, Number(m[3] || 1));
  };

  const dateLabel = (album) => {
    const raw = String((album && album.date) || "").trim();
    const m = raw.match(/^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?/);
    if (!m) return album && album.year ? album.year : "";
    return [m[1], m[2], m[3]].filter(Boolean).join(".");
  };

  const sortedAlbums = () => {
    const list = ALBUMS.slice();
    list.sort((a, b) => {
      if (state.sort === "most" || state.sort === "least") {
        const n = (a.files.length || 0) - (b.files.length || 0);
        if (n) return state.sort === "least" ? n : -n;
        return String(a.name).localeCompare(String(b.name));
      }
      const d = dateStamp(a) - dateStamp(b);
      if (d) return state.sort === "oldest" ? d : -d;
      return String(a.name).localeCompare(String(b.name));
    });
    return list;
  };

  const setTitle = (path) => {
    if (title) title.textContent = path;
  };

  const coverOf = (album) => album.cover || (album.files[0] && album.files[0].src);

  const fadeThumb = (img) => {
    const on = () => img.classList.add("is-on");
    img.addEventListener("load", on, { once: true });
    if (img.complete && img.naturalWidth) on();
  };

  const waitEl = () => {
    const s = document.createElement("span");
    s.className = "os-photos__wait";
    s.setAttribute("aria-hidden", "true");
    return s;
  };

  const fillFrame = (frame, img, preview, hi) => {
    if (!frame || !img) return;
    frame._gen = (frame._gen || 0) + 1;
    const gen = frame._gen;
    const show = (src) => {
      if (frame._gen !== gen) return;
      if (img.getAttribute("src") !== src) img.setAttribute("src", src);
      img.classList.add("is-on");
      frame.classList.remove("is-wait");
    };
    const cached = loaded.has(preview);
    if (!cached) frame.classList.add("is-wait");
    loadImg(preview).then(() => {
      show(preview);
      if (!hi || hi === preview) return;
      return loadImg(hi).then(() => show(hi));
    }).catch(() => {
      if (frame._gen !== gen) return;
      frame.classList.remove("is-wait");
    });
  };

  const fs = document.createElement("div");
  fs.className = "os-photos-fs";
  fs.setAttribute("role", "dialog");
  fs.setAttribute("aria-modal", "true");
  fs.innerHTML = `<img class="os-photos-fs__wash" data-fs-wash alt="" aria-hidden="true" decoding="async">
    <div class="os-photos-fs__bar">
      <span class="os-photos-fs__path" data-fs-path>C:\\FIVEHEARTS\\PHOTOS</span>
      <span class="os-photos-fs__lcd" data-fs-count></span>
      <button type="button" class="os-photos-fs__x" data-fs-close aria-label="Close">×</button>
    </div>
    <div class="os-photos-fs__body">
      <button type="button" class="os-photos-fs__arrow os-photos-fs__arrow--l" data-fs-prev aria-label="Previous">←</button>
      <figure class="os-photos-fs__frame is-wait" data-fs-frame>
        <span class="os-photos__wait" aria-hidden="true"></span>
        <img class="os-photos-fs__img" data-fs-shot alt="" decoding="async">
      </figure>
      <button type="button" class="os-photos-fs__arrow os-photos-fs__arrow--r" data-fs-next aria-label="Next">→</button>
    </div>
    <p class="os-photos-fs__cap" data-fs-name></p>`;
  document.body.appendChild(fs);

  const hideFull = () => {
    fs.classList.remove("is-open");
    document.body.classList.remove("is-photos-full");
    if (state.mode === "full") {
      state.mode = "album";
      if (state.album) setTitle("C:\\FIVEHEARTS\\PHOTOS\\" + state.album.name);
    }
  };

  const showFull = (i) => {
    const album = state.album;
    if (!album || !album.files.length) return;
    const n = album.files.length;
    state.i = ((i % n) + n) % n;
    state.mode = "full";
    const file = album.files[state.i];
    const path = "C:\\FIVEHEARTS\\PHOTOS\\" + album.name + "\\" + file.name;
    setTitle(path);
    fs.classList.add("is-open");
    document.body.classList.add("is-photos-full");
    fs.querySelector("[data-fs-path]").textContent = path;
    fs.querySelector("[data-fs-count]").textContent = pad(state.i + 1) + " / " + pad(n);
    fs.querySelector("[data-fs-name]").textContent = file.desc ? file.name + " — " + file.desc : file.name;
    const wash = fs.querySelector("[data-fs-wash]");
    if (wash) wash.src = sized(file.src, MEDIUM);
    fillFrame(
      fs.querySelector("[data-fs-frame]"),
      fs.querySelector("[data-fs-shot]"),
      sized(file.src, MEDIUM),
      sized(file.src, FULL)
    );
    warm(album.files[(state.i + 1) % n], MEDIUM);
    warm(album.files[(state.i + 1) % n], FULL);
    warm(album.files[(state.i - 1 + n) % n], MEDIUM);
    warm(album.files[(state.i - 1 + n) % n], FULL);
  };

  fs.addEventListener("pointerdown", (e) => e.stopPropagation());
  fs.querySelector("[data-fs-prev]").addEventListener("click", (e) => {
    e.stopPropagation();
    showFull(state.i - 1);
  });
  fs.querySelector("[data-fs-next]").addEventListener("click", (e) => {
    e.stopPropagation();
    showFull(state.i + 1);
  });
  fs.querySelector("[data-fs-close]").addEventListener("click", hideFull);

  const showIndex = () => {
    hideFull();
    state.mode = "index";
    state.album = null;
    setTitle("C:\\FIVEHEARTS\\PHOTOS");
    root.innerHTML = `<div class="os-photos__bar">
        <p class="os-photos__lead">Albums. Open one. Have a look.</p>
        <label class="os-photos__sort">sort by
          <select data-photos-sort>
            <option value="newest"${state.sort === "newest" ? " selected" : ""}>date · newest</option>
            <option value="oldest"${state.sort === "oldest" ? " selected" : ""}>date · oldest</option>
            <option value="most"${state.sort === "most" ? " selected" : ""}>size · most</option>
            <option value="least"${state.sort === "least" ? " selected" : ""}>size · least</option>
          </select>
        </label>
      </div>
      <div class="os-photos__albums"></div>`;
    root.querySelector("[data-photos-sort]").addEventListener("change", (e) => {
      state.sort = SORTS.includes(e.target.value) ? e.target.value : "newest";
      showIndex();
    });
    const list = root.querySelector(".os-photos__albums");
    sortedAlbums().forEach((album) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "os-photos__album";
      const cover = coverOf(album);
      const when = dateLabel(album);
      btn.innerHTML = `${cover ? `<img alt="" width="420" height="420" loading="lazy" decoding="async" src="${sized(cover, THUMB)}">` : `<span class="os-photos__empty">empty</span>`}
        <span class="os-photos__aname">${album.name}</span>
        <span class="os-photos__ameta">${when ? when + " · " : ""}${album.files.length} files</span>
        ${album.desc ? `<span class="os-photos__adesc">${album.desc}</span>` : ""}`;
      const img = btn.querySelector("img");
      if (img) fadeThumb(img);
      btn.addEventListener("click", () => showAlbum(album));
      list.appendChild(btn);
    });
  };

  const showAlbum = (album) => {
    hideFull();
    state.mode = "album";
    state.album = album;
    setTitle("C:\\FIVEHEARTS\\PHOTOS\\" + album.name);
    root.innerHTML = `<div class="os-photos__bar">
        <button type="button" class="os-photos__back" data-photos-back>← albums</button>
        <p class="os-photos__lead">${album.name}${dateLabel(album) ? " · " + dateLabel(album) : ""}</p>
      </div>
      ${album.desc ? `<p class="os-photos__copy">${album.desc}</p>` : ""}
      <div class="os-photos__grid"></div>`;
    root.querySelector("[data-photos-back]").addEventListener("click", showIndex);
    const grid = root.querySelector(".os-photos__grid");
    album.files.forEach((file, i) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "os-photos__cell is-wait";
      btn.appendChild(waitEl());
      const img = document.createElement("img");
      img.alt = "";
      img.loading = "lazy";
      img.decoding = "async";
      img.src = sized(file.src, THUMB);
      const name = document.createElement("span");
      name.textContent = file.name;
      btn.appendChild(img);
      btn.appendChild(name);
      fadeThumb(img);
      img.addEventListener("load", () => btn.classList.remove("is-wait"), { once: true });
      if (img.complete && img.naturalWidth) btn.classList.remove("is-wait");
      btn.addEventListener("click", () => {
        state.album = album;
        showFull(i);
      });
      grid.appendChild(btn);
      if (i < 3) warm(file, MEDIUM);
    });
  };

  const back = () => {
    if (state.mode === "full") hideFull();
    else if (state.mode === "album") showIndex();
  };

  const frontPhotos = () => win && win.classList.contains("is-open") && win.classList.contains("is-front");

  addEventListener("keydown", (e) => {
    if (!state.live) return;
    if (state.mode !== "full" && !frontPhotos()) return;
    if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if (e.key === "Escape" && state.mode !== "index") {
      e.preventDefault();
      e.stopImmediatePropagation();
      back();
      return;
    }
    if (state.mode !== "full") return;
    if (e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "a" || e.key === "A") {
      e.preventDefault();
      showFull(state.i - 1);
    } else if (e.key === "ArrowRight" || e.key === "ArrowDown" || e.key === "d" || e.key === "D") {
      e.preventDefault();
      showFull(state.i + 1);
    }
  }, true);

  const photosOpen = () => {
    state.live = true;
    if (!root.childElementCount) showIndex();
  };

  addEventListener("fh:win", (e) => {
    const d = e.detail || {};
    if (d.name !== "photos") return;
    if (d.action === "close") {
      state.live = false;
      hideFull();
      state.mode = "index";
      state.album = null;
      root.innerHTML = "";
      setTitle("C:\\FIVEHEARTS\\PHOTOS");
      return;
    }
    if (d.action === "open") photosOpen();
  });

  window.FH = window.FH || {};
  window.FH.photosOpen = photosOpen;
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
